const translationFunction = (
  obj: any | Object | string,
  { reverse } = { reverse: false },
  translationMap: string[][]
) => {
  const phraseToTranslate = (phrase: [string, string]) => (reverse ? phrase[1] : phrase[0]);
  const phraseTranslation = (phrase: [string, string]) => (reverse ? phrase[0] : phrase[1]);

  const translFn = value => {
    if (typeof value === 'object' || Array.isArray(value)) {
      return translationFunction(value, { reverse }, translationMap);
    }
    if (typeof value === 'string') {
      translationMap.map((phrase: any) => {
        value = (value as string).split(phraseToTranslate(phrase)).join(phraseTranslation(phrase));
        return value;
      });
      return value.trim();
    }
    return value;
  };

  if (Array.isArray(obj)) {
    obj = obj.map(item => {
      return translFn(item);
    });
  } else if (typeof obj === 'object') {
    for (const prop in obj) {
      obj[prop] = translFn(obj[prop]);
    }
  } else if (typeof obj === 'string') {
    return translFn(obj);
  }

  return obj;
};

export default translationFunction;
